import { TextureSource } from "../../../types";
import { texture } from "../../../utils/webgl";
import { Mix } from "../programs/mix/mix";
import { WebglTransformerPipeline } from "../webgl-transormer-pipeline";

export class BackgroundImagePipeline extends WebglTransformerPipeline {
    public inputImage?: ImageBitmap | TextureSource | WebGLTexture;
    public inputBackgroundImage?: ImageBitmap | TextureSource | WebGLTexture;
    public inputMask?: ImageBitmap | TextureSource | WebGLTexture;

    public preciseMaskEnabled: boolean = true;

    constructor(private readonly context: WebGLRenderingContext) {
        super();
        const defaultOptions = {
            context,
            height: context.canvas.height,
            width: context.canvas.width,
        };

        const mix = new Mix({ ...defaultOptions, disableFramebuffer: true });

        this.addStep({
            program: mix,
            getUniforms: () => {
                return {
                    background: texture(context, this.inputBackgroundImage),
                    foreground: texture(context, this.inputImage),
                    threshold: texture(context, this.inputMask),
                };
            },
        });
    }

    public setData(
        image?: ImageBitmap | TextureSource | WebGLTexture,
        mask?: ImageBitmap | TextureSource | WebGLTexture
    ) {
        this.inputImage = image;
        this.inputMask = mask;
    }
}
